import { useCallback, useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CardProduct from "./CardProduct";
import { useProductListQueryPbf } from "../../../hooks/purchaseHook/useProductListQueryPbf";

const RecentSearchProductSwiper = () => {
  const sliderRef = useRef(null);

  const { data: dataList, isFetching: isLoading } = useProductListQueryPbf({
    search: "",
    offset: 1,
    limit: 10,
    label_ids: [],
    category_ids: [], // not currently used
    principal_ids: [],
    offer_type: "search_by_user",
    order_by: "created_desc",
  });

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <div className="w-full overflow-hidden relative px-12 ">
      <div
        className="z-5 bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute left-0 top-0 bottom-0 my-auto"
        id="slideLeft"
        onClick={() =>
          (document.getElementById("containerScrollRecent").scrollLeft -= 220)
        }
      >
        <FaChevronLeft />
      </div>
      <div
        className="scroll-smooth z-5 bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute right-0 top-0 bottom-0 my-auto"
        id="slideRight"
        onClick={() =>
          (document.getElementById("containerScrollRecent").scrollLeft += 220)
        }
      >
        <FaChevronRight />
      </div>

      <div
        className="w-full flex gap-2 overflow-x-auto hide-scroll scroll-smooth"
        id="containerScrollRecent"
      >
        {dataList && !isLoading && dataList.data && dataList.total_data > 0 ? (
          // (dataList.product?.length > 0 && dataList.so?.length > 0
          //   ? [...dataList.product, ...dataList.so]
          //   : dataList.product?.length > 0 && dataList.so?.length === 0
          //   ? dataList.product
          //   : dataList.product?.length === 0 && dataList.so?.length > 0
          //   ? dataList.so
          //   : []
          // )
          dataList.data.map((item, i) => (
            <div className="w-fit">
              <CardProduct product={item} type={item.product_so_id ? 2 : 1} />
            </div>
          ))
        ) : isLoading ? (
          [...Array(8).keys()].map((item) => {
            return (
              <div className="w-fit">
                <CardProduct isLoadingCard={true} />
              </div>
            );
          })
        ) : (
          <p>Tidak ada data</p>
        )}
      </div>
    </div>
  );
};

export default RecentSearchProductSwiper;
